import React, { useEffect, useRef } from "react";
import "./whyHK.css";
import { useLanguage } from "../LanguageContext/LanguageContext";
import VerifiedIcon from "@mui/icons-material/Verified";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import HandshakeIcon from "@mui/icons-material/Handshake";

function WhyHK() {
  const sectionRef = useRef(null);
  const { t, lang } = useLanguage();

  useEffect(() => {
    const circles = sectionRef.current.querySelectorAll(
      ".circle1, .circle2, .circle3, .circle4"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    circles.forEach((circle) => observer.observe(circle));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="circlesContainrer" ref={sectionRef}>
      <h1 className="titleSmallScreen" style={{ direction: lang === "ar" ? "rtl" : "ltr" }}>
        {lang === "ar" ? "؟HK لماذا" : "WHY HK?"}
      </h1>

      <div className="circleDual">
        <div className="circle1">
          <VerifiedIcon className="circleIcon" />
          <h1>{lang === "ar" ? "ثقة" : "Trust"}</h1>
          <p>{t.trust}</p>
        </div>
        <div className="circle3">
          <MiscellaneousServicesIcon className="circleIcon" />
          <h1>{lang === "ar" ? "خدمات" : "Services"}</h1>
          <p>{t.services}</p>
        </div>
      </div>

      <h1 className="title" style={{ direction: lang === "ar" ? "rtl" : "ltr" }}>
        {lang === "ar" ? "؟HK لماذا" : "WHY HK?"}
      </h1>

      <div className="circleDual">
        <div className="circle2">
          <WorkspacePremiumIcon className="circleIcon" />
          <h1>{lang === "ar" ? "خبرة" : "Experience"}</h1>
          <p>{t.experience}</p>
        </div>
        <div className="circle4">
          <HandshakeIcon className="circleIcon" />
          <h1>{lang === "ar" ? "شراكة" : "Partnership"}</h1>
          <p>{t.partnership}</p>
        </div>
      </div>
    </div>
  );
}

export default WhyHK;
